


 export  const data = [{
     id:'0',
     description:'Do I know enough about my customers?  ',
     className:'leadership',
     bgColor:'#034EA2',
     tag:'hrID',
     bgImage:'img1'
},
    {
        id:'1',
        description:'Who are  my top 10 customers? ',
        bgColor:'#034EA2',
        className:'leadership',
        bgImage:'img1'
    },{
        id:'2',
        description:'What do I do with those tons of early morning reports?',
         bgColor:'#034EA2',
        className:'leadership',
         bgImage:'img1'
    },{
         id:'3',
         description:'What’s my funnel this month? ',
         bgColor:'#812990',
         className:'sales',
         tag:'hrID',
         bgImage:'img2'
     },
     {
         id:'4',
         description:'Do I have enough leads to meet this month’s target?',
         bgColor:'#812990',
         className:'sales',
         bgImage:'img2'
     },{
         id:'5',
         description:'Can you remind me about the customer calls to be made?',
         bgColor:'#812990',
         className:'sales',
         bgImage:'img2'
     },{
        id:'6',
        description  :'How can I manage incentives effectively?',
         bgColor:'#812990',
        className:'sales',
        tag:'financeId',
         bgImage:'img2'
    },{
        id:'7',
        description:'Can I digitise my employee on-boarding process?',
         bgColor:'#CBDB2A',
        className:'hr',
         bgImage:'img3'
    },
    {
        id:'8',
        description:'How do I make sure I get consistent feedback from my employees?',
        bgColor:'#CBDB2A',
        className:'hr',
        bgImage:'img3'
    },{
        id:'9',
        description  :'Can I engage with my employees and get quick insights?',
         bgColor:'#CBDB2A',
        className:'hr',
        tag:'salesId',
         bgImage:'img3'
    },{
        id:'10',
        description  :'Can I tightly follow my customer deliveries?',
         bgColor:'#F79434',
        className:'operations',
         bgImage:'img4'
    },{
        id:'11',
        description:'How can I make sure all customers are responded on time?',
         bgColor:'#F79434',
        className:'operations',
         bgImage:'img4'
    },
    {
        id:'12',
        description:'Can I get to see my field service team in real-time and assign them tasks',
        bgColor:'#F79434',
        className:'operations',
        bgImage:'img4'
    },{
        id:'13',
        description:'How do I manage employee claims at ease?',
         bgColor:'#20BEC6',
        className:'finance',
         bgImage:'img5'
    },{
        id:'14',
        description  :'Can I digitise my vendor on-boarding, PO generation and Asset Management?',
         bgColor:'#20BEC6',
        className:'finance',
         bgImage:'img5'
    },{
        id:'15',
        description:'Are we on track with our collection targets?',
         bgColor:'#20BEC6',
        className:'finance',
         bgImage:'img5'
    },
    {
        id:'16',
        description:'Can I have one platform to manage all the different processes?',
        bgColor:'#009C56',
        className:'technology',
        bgImage:'img6'
    },{
        id:'17',
        description:'Can I quickly see the health of all the projects running in one place?',
         bgColor:'#009C56',
        className:'technology',
         bgImage:'img6'
    }]

  const customiseYourApp = {
     id:'1',
     description:'Manage Projects and tasks seamlessly to keep everyone in the loop',
     app:'hr',
     title:'Build your own',
     image:'buildYourOwn',
      noClick:true
 }

 export const appsData = [{
     id:'1',
     description:'A swipe is all it takes. It is as easy as it gets',
     app:'hr',
     title:'Attendance/Leave  ',
     image:'attendance',
 },
     {
         id:'2',
         description:'Create - distribute - collect - analyse - manage all your surveys on a single platform',
         title:'Survey/Feedback',
         app:'hr',
         image:'survey'
     },{
         id:'3',
         description:'Connect, Engage, Celebrate and more. A social tool with a purpose',
         title:'Social',
         app:'hr',
         image:'social'
     },{
         id:'4',
         description  :'Stackup great applicants by empowering your employees with a supercharged referral program',
         app:'hr',
         title:'Referral Program',
         image:'referal'
     },{
         id:'5',
         description:'Track your teams\' learning needs, find in-house talents. A simplified tool for all learning initiatives',
         title:'Learning',
         app:'hr',
         image:'learning'
     },
     {
         id:'6',
         description:'From planning your business trips to approvals all under one roof',
         app:'admin',
         title:'Travel Management',
         image:''
     },
     {
         id:'7',
         description:'A clean and intuitive project management tool for teams of any size',
         title:'Projects & Tasks',
         app:'admin',
         image:'projectAndtask'
     },{
         id:'8',
         description:'No more of those thick registers and email approvals. Manage your visitors digitally',
         title:'Visitor Management',
         app:'admin',
         image:''
     },{
         id:'9',
         description:'Manage the security personnel deployment with comprehensive incident reporting and more',
         app:'admin',
         title:'Security',
         image:'security'
     },{
         id:'10',
         description:'A communication system that allows to deliver instant alerts to the right people in case of emergencies.',
         title:'SoS',
         app:'admin',
         image:''
     },
     {
         id:'11',
         description:'Simple, secure billing & invoicing solution on-the-go with hubbler',
         title:'Billing ',
         app:'finance',
         image:'billing'
     },{
         id:'12',
         description:'Be efficient and get paid faster with hubbler collections',
         title:'Collections',
         app:'finance',
         image:'collection'
     },{
         id:'13',
         description  :'Can my entire sales force be accounted for in a single place ?',
         title:'Purchase Requisition',
         app:'finance',
         image:'purchaseRequest'
     },{
         id:'14',
         description  :'A solution that helps organisations with better visibility across books of business.',
         title:'Claims',
         app:'finance',
         image:'claims'
     },{
         id:'15',
         description:'Optimize management policies/strategies by tracking the fixed & mobile assets of the company',
         title:'Asset Management',
         app:'finance',
         image:'AssetMgt'
     },{
         id:'16',
         description:'Don\'t just manage issues but seek greater visibility to resolve the root cause',
         app:'service',
         title:'Service Ticketing ',
         image:'serviceTicketing'
     },
     {
         id:'17',
         description:'A clean and intuitive project management tool for teams of any size',
         title:'Projects and Tasks',
         app:'service',
         image:'projectAndtask'
     },{
         id:'18',
         description:'Take advantage of real-time location of your teams. Assign jobs to the sales executive nearest to the customer.',
         title:'Location Management',
         app:'service',
         image:'location'
     },{
         id:'19',
         description  :'From the order taking to the product delivery, on a single platform. No more loose ends',
         app:'service',
         title:'Delivery',
         image:'delivery'
     },
     {
         id:'20',
         description  :'Integrate and automate sales, marketing and customer support. Suitable for business of all sizes and industries. ',
         app:'service',
         title:'CRM',
         image:'crm'
     },
     {
         id:'21',
         description:'From generating an opportunity to onboarding - capture the entire life cycle of your customer.',
         title:'Lead Tracker',
         app:'sales',
         image:'leadTracker'
     },{
         id:'22',
         description:'Centralise your entire customer database. Assign and distribute customers effectively to your sales team.',
         title:'Customer Management',
         app:'sales',
         image:'customerManagement'
     },{
         id:'23',
         description  :'Give your team visibility to their targets and their achievements as they make more wins.',
         title:'Incentives',
         app:'sales',
         image:'incentives'
     },{
         id:'24',
         description  :'Take advantage of real-time location of your team, assign new tasks / jobs to the sales executive nearest to the customer.',
         title:'Location Management',
         app:'sales',
         image:'location'
     },{
         id:'25',
         description:'Now get the distributors, retailers on to the same platform. Manage their sales, performance and their offers in real-time.',
         title:'Distributor Management',
         app:'sales',
         image:'distributorMgt'
     },{
         id:'26',
         description:'Get rid of those paper books. Now take orders with real-time visibility of inventory. All with a few taps.',
         title:'Order Management',
         app:'operations',
         image:'orderMngt'
     },
     {
         id:'27',
         description:'Centralised repository of your vendors. Create your own process and onboard your vendors.',
         title:'Vendor Management ',
         app:'operations',
         image:'customerIcon'
     },{
         id:'28',
         description:'Buy, sell or book - whatever your business is, our inventory can handle all complexities.',
         title:'Inventory Management',
         app:'operations',
         image:'inventory'
     },
     {
         id:'29',
         description:'Take advantage of real-time location of your team, assign new tasks / jobs to the operations executive nearest to the customer.',
         title:'Location Management',
         app:'operations',
         image:'location'
     },{
         id:'30',
         description:'A clean and intuitive project management tool for teams of any size.',
         title:'Projects & Tasks',
         app:'operations',
         image:'projectAndtask'
     },{
         ...customiseYourApp,id:'31',app:'hr'
     },
     {
         ...customiseYourApp,id:'32',app:'operations'
     },
     {
         ...customiseYourApp,id:'33',app:'sales'
     },
     {
         ...customiseYourApp,id:'34',app:'service'
     },
     {
         ...customiseYourApp,id:'35',app:'finance'
     },
     {
         ...customiseYourApp,id:'36',app:'admin'
     }]

 export const hubblerReviewData = [{
     id:'1',
     description:'For me, stability & growth is everything across my businesses; While ERPs sync processes; I review growth through Hubbler’s Analytical Dashboard. Precise insights from innumerable data points. A true savior!',
     name:`Ravi Machani
      MD, Machani Group`,
      },
     {
         id:'2',
         description:'Hubbler has revolutionized the way we collaborate, interact and report within our organization. Their team is young, energetic, extremely proactive to all our custom needs; we vouch for their product and team!',
         name:`Rachit Bhandary
         Dir, BioMedix`
     },{
         id:'3',
         description:"Hubbler's Lead Management has given us a real time view of our funnel, deal status and revenue. Substantial time on reviewing excel sheets is now used far more productively. Our swift decisions has ensured faster deal closures!",
         name:`Maharishi Sridhar
          Dir, Syncotts Sports`
     },{
         id:'4',
         description  :'Hubbler has exceeded our expectations! Amazed by the many Hubbler features such as attendance, leave forms, reimbursement etc., which  simplifies administration.',
         name:`Dr. Sanchita
            Dept of Community Oncology`,
     }]

 export const hubblerStudioData = [{
     id:'1',
     description:'It all starts with an idea',
     title:'Start',
     activeLabel:'studioActive'
 },
     {
         id:'2',
         description:'Decide data points to capture at every stage',
         title:'Create'
     },{
         id:'3',
         description:'Connect all stages together  ',
         title:'Link'
     },{
         id:'4',
         description:'Assign right people ',
         title:'Allocate',
     },{
         id:'5',
         description:'Done, already!',
         title:'Publish'
     },]

 export const companyLogos = [
     {id:'1',imageName:'1',companyName:'1'},
     {id:'2',imageName:'2',companyName:'2'},
     {id:'3',imageName:'3',companyName:'3'},
     {id:'3',imageName:'3',companyName:'3'},
     {id:'4',imageName:'4',companyName:'4'},
     {id:'5',imageName:'5',companyName:'5'},
     {id:'6',imageName:'6',companyName:'6'},
     {id:'7',imageName:'7',companyName:'7'}
     ]


// WEBPACK FOOTER //
// ./src/data/webData.js